<template>
  <v-card flat>


        <v-switch persistent-hint
          v-model="payload.with_appt_details"
          label="Include appointment information"
          class="pa-0 ma-0 mb-2"
          hint="Include standard smart-formatted appointment information" />
        <v-checkbox persistent-hint
          v-if="payload.with_appt_details"
          :disabled="!payload.with_appt_details"
          v-model="payload.customize_appt_details"
          label="Customize"
          hint="Customize which appointment information is included in your notification" />

    <v-divider/>
    <template v-if="payload.customize_appt_details" >
      <p class="caption">Select which information about the appointment you would like to include in your notification</p>

      <v-card flat>
        <v-card-title class="pl-0">
          <v-switch small persistent-hint class="pa-0 ma-0" v-model="payload.with_product"
            label="Include appointment information header" hint="e.g., {appointment type} with {person} at {space}" />
        </v-card-title>
      </v-card>

      <!-- <template v-if="payload.with_product">
        <v-select label="Select a template to display the appointment type information" />
      </template> -->

      <v-switch persistent-hint small
        class="pa-0 ma-0"
        v-model="payload.with_when"
        label="Include date and time"
        hint="e.g.: When: Mon 01 Apr 2022 at 08:00 AM" />

      <v-card flat>
        <v-card-title class="pl-0">
          <v-switch small class="pa-0 ma-0" v-model="payload.with_where" label="Include address information" />
        </v-card-title>
        <v-card outlined v-if="payload.with_where" class="caption">
          <v-card-title class="overline">What location information would you like to include</v-card-title>
          <v-card-text>
            <v-switch small persistent-hint
              v-model="payload.where_address_name"
              class="pa-0 ma-0 mb-2"
              label="Location name"
              hint="The name of the location" />
            <v-switch small persistent-hint
              v-model="payload.where_address_address"
              hint="The physical address - typically populated by google maps, but you can edit it to make it more precise"
              class="pa-0 ma-0 mb-2"
              label="Location address" />
            <v-switch small persistent-hint
              v-model="payload.where_address_maps_link" class="pa-0 ma-0 mb-2"
              label="Link to maps"
              hint="Will use an autogenerated link based on information from Google maps, or your custom map link if you provide one" />
            <v-switch small persistent-hint
              v-model="payload.where_address_notes"
              class="pa-0 ma-0"
              label="Location notes"
              hint="Uses the 'extra information' from your location" />

            <v-alert type="info" text border="left" class="py-1 caption mt-3" tile >
              Note: The above only apply to standard appointments.
              Flexible appointments (home visits), or online appointments will correctly insert the relevant information from the appointment
            </v-alert>
          </v-card-text>


          <v-expansion-panels>
            <v-expansion-panel >
              <v-expansion-panel-header>
                <span>
                  <v-icon>mdi-map-marker</v-icon>
                  Edit location information
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <edit-location-form />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-card>

      <v-card flat>
        <v-card-title class="overline pl-0 pb-0">
          Links
        </v-card-title>

        <v-switch small persistent-hint
          v-model="payload.with_form_link"
          class="pa-0 ma-0 mt-4"
          label="Link to forms"
          hint="Include a smart link which will include any forms that the client needs to fill out" />
        <v-alert
          v-if="!payload.with_form_link"
          type="warning" text border="left" class="caption py-1 mt-2" >
          <strong>Note:</strong>
          This will override settings in your JotForm integration to include forms in notifications.
          Links to forms are only included if you have the JotForm integration with linked forms and the client has not yet filled out all required forms.
          (forms are still linked from the appointment page (link below), and you can also manually share them)
        </v-alert>
        <v-switch small persistent-hint
          v-model="payload.with_appt_link"
          class="pa-0 ma-0 mt-4"
          label="Link to appointment"
          hint="Include a link to the appointment detail page" />
      </v-card>
    </template>

    <v-card v-if="payload.with_appt_details" flat>
      <v-card-title class="overline pl-0 pb-0">
        Extra details
      </v-card-title>

      <v-row >
        <v-col>
          <v-switch persistent-hint small
            class="pa-0 ma-0"
            label="Appointment type notes"
            v-model="payload.product_notes"
            hint="Include custom notes for the specific appointment type" />
        </v-col>
        <v-col class="text-right" >
          <v-btn x-small outlined text @click="editproductnotes=true">
            Manage notes
          </v-btn>
        </v-col>
        <v-dialog v-model="editproductnotes">
          <product-notes @close="editproductnotes=false" />
        </v-dialog>
      </v-row>

    </v-card>

  </v-card>
</template>
<script>
import ProductNotes from './ProductNotes.vue'
import EditLocationForm from './EditLocationForm.vue'
import Vue from 'vue'
export default {
  name: 'AppointmentInformationForm',
  props: {
    value: { type: Object }
  },
  components: { ProductNotes, EditLocationForm },
  data () {
    return {
      editproductnotes: false,
      payload: {
        with_appt_details: true,
        customize_appt_details: false,
        with_product: true,
        product_notes: true,
        with_where: true,
        where_address_name: true,
        where_address_address: true,
        where_address_maps_link: true,
        where_address_notes: true,

        with_when: true,
        with_appt_link: true,
        with_form_link: true
      }
    }
  },
  mounted () {
    this.payload = this.value
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.payload = this.value
      }
    },
    payload: {
      deep: true,
      handler() {
        this.$emit('input', this.payload)
        this.$emit('change', this.payload)
      }
    },
    withApptDetails () {
      if (this.withApptDetails === false) {
        Vue.set(this.payload, 'customize_appt_details', false)
      }
    }
  },
  computed: {
    withApptDetails () {
      return this.payload.with_appt_details
    }
  }
}
</script>
